if (!customElements.get('sh-product-delivery')) {
  customElements.define('sh-product-delivery', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.render.bind(this);
      this.countryChange = event => {
        if (event.target.matches('[data-country-select]')) this.render();
      };
      document.addEventListener('visibilitychange', this.refresh);
      document.addEventListener('change', this.countryChange);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.refresh);
      document.removeEventListener('change', this.countryChange);
    }

    render() {
      this.hidden = true;
      try {
        const markets = JSON.parse(this.dataset.markets || '{}');
        let country = this.dataset.country;
        try {
          const key = 'sh-cart-country-v2-' + location.hostname + '-' + this.dataset.currency;
          const destination = JSON.parse(sessionStorage.getItem(key));
          if (destination?.country) country = destination.country;
        } catch {}
        const config = markets[country];
        if (!config) return;
        const minimum = Number(config[3]);
        const maximum = Number(config[4]);
        if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum < 0 || maximum < minimum) return;
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
        const start = new Date(`${values.year}-${values.month}-${values.day}T12:00:00Z`);
        const addBusinessDays = (date, days) => {
          const result = new Date(date);
          for (let added = 0; added < days;) {
            result.setUTCDate(result.getUTCDate() + 1);
            if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) added++;
          }
          return result;
        };
        const dispatch = addBusinessDays(start, 1);
        const format = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang, {
          weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Madrid'
        });
        const dates = [addBusinessDays(dispatch, minimum), addBusinessDays(dispatch, maximum)];
        this.querySelector('[data-delivery-label]').textContent = this.dataset.copy.replace('{dates}', '').trim();
        this.querySelector('[data-delivery-dates]').textContent = dates.map(date => format.format(date)).join(' – ');
        this.hidden = false;
      } catch {}
    }
  });
}
